import React, { useCallback, useEffect } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import { BOARDS_LOADING } from "../../constants/loading.constant";
import { useBoardCore } from "../../cores/boards";
import { NoData } from "../component/NoData";
import { UpdateLoadingCard } from "../component/UpdateLoadingCard";
import Content from "../layout/Content";
import { useIntl } from "react-intl";
import { Header2 } from "../layout/Header2";
import Layout from "../layout/Layout";
import SideModal from "../layout/SideModal";
import { useMeCore } from "../../cores/me";
import BoardCard from "../component/boards/BoardCard";
import { BoardType } from "../../cores/boards/constants/board-type.constant";
import { useRouterCore } from "../../cores/router";
import CreateBoard from "../component/boards/modal/CreateBoard";
import {
  BOARD_CREATE_CONFIG,
  BOARD_USERS_MODAL,
  MORE_INFO_HEADER_ACTIVITY,
} from "../../constants/modal.constant";
import { useGlobalCore } from "../../cores/globals";
import { YoutubeModal } from "../component/YoutubeModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ProductGuideModal } from "../component/guides/ProductGuideModal";
import { ACTIVITY_BOARDS_GUIDE_STEPS } from "../component/guides/productGuideConfigs";
import { useProductGuideQuery } from "../../hooks/useProductGuideQuery";

export const ActivityBoardsScreen = () => {
  const intl = useIntl();
  const { showGuide: showActivityGuide, closeGuide: closeActivityGuide } =
    useProductGuideQuery("activities");
  const { turnOffModal, turnOnModal, getModalVisibility, isModal, getModalContent } =
    useGlobalCore();
  const { company, companyPlan, companyRole, isAdmin, isReseller } =
    useMeCore();
  const { boards, getActivityBoards } = useBoardCore();
  const { goToSocial } = useRouterCore();

  useEffect(() => {
    if (
      !companyPlan?.rules.allowActivityBoard ||
      (!companyRole?.activities &&
        !companyRole?.owner &&
        !companyRole?.admin &&
        !companyRole?.agent &&
        !isAdmin &&
        !isReseller)
    )
      goToSocial();
  }, [companyPlan, companyRole, isAdmin, isReseller, goToSocial]);

  const toggleSideModal = useCallback(() => {
    turnOnModal(BOARD_CREATE_CONFIG, true);
  }, [turnOnModal]);

  useEffect(() => {
    getActivityBoards(company?.id!);
  }, [company, getActivityBoards]);

  useEffect(() => {}, [boards]);

  return (
    <Layout>
      <Header2
        title=""
        mb={false}
      />
      <Content className="activity-boards-page">
        <Container fluid>
          <div className="activity-boards-hero">
            <div className="activity-boards-hero-top">
              <div className="activity-boards-hero-title-wrap">
                <h2 className="activity-boards-hero-title mb-0">
                  {intl.formatMessage({ id: "app.activity.title" })}
                </h2>
                <FontAwesomeIcon
                  icon={["fas", "info-circle"]}
                  className="activity-boards-hero-help pointer"
                  onClick={() => turnOnModal(MORE_INFO_HEADER_ACTIVITY, true)}
                />
              </div>
              {boards.length !== 0 && (
                <Button
                  className="activity-boards-create-btn"
                  onClick={toggleSideModal}
                >
                  {intl.formatMessage({ id: "app.activity.createBoard" })}
                </Button>
              )}
            </div>
            <p className="activity-boards-hero-subtitle mb-0">
              Gestiona y organiza tus tableros de forma simple.
            </p>
          </div>
          <UpdateLoadingCard
            loadingId={BOARDS_LOADING}
            text={intl.formatMessage({ id: "app.activity.updatingBoard" })}
          />
          {!boards.length && (
            <NoData
              image="generic4"
              text={intl.formatMessage({ id: "app.activity.notHaveBoard" })}
              actionLabel={intl.formatMessage({
                id: "app.activity.createBoard",
              })}
              action={toggleSideModal}
              horizontal
            />
          )}
          <Row className="activity-boards-grid">
            {boards.map((board) => (
              <Col lg="3" md="4" sm="6" xs="12" key={board.id} className="mb-4">
                <BoardCard board={board} />
              </Col>
            ))}
          </Row>
        </Container>
      </Content>
      <SideModal
        active={isModal(BOARD_CREATE_CONFIG)}
        visible={getModalVisibility(BOARD_CREATE_CONFIG)}
        onClose={() => {
          turnOffModal(BOARD_CREATE_CONFIG);
        }}
      >
        <CreateBoard
          type={BoardType.ACTIVITY}
          onSuccess={() => {
            turnOffModal(BOARD_CREATE_CONFIG);
          }}
        />
      </SideModal>

      <SideModal
        active={isModal(BOARD_USERS_MODAL)}
        visible={getModalVisibility(BOARD_USERS_MODAL)}
        onClose={() => turnOffModal(BOARD_USERS_MODAL)}
        left
      >
        {getModalContent(BOARD_USERS_MODAL)}
      </SideModal>

      <SideModal
        active={isModal(MORE_INFO_HEADER_ACTIVITY)}
        visible={getModalVisibility(MORE_INFO_HEADER_ACTIVITY)}
        onClose={() => {
          turnOffModal(MORE_INFO_HEADER_ACTIVITY);
        }}
      >
        <YoutubeModal
          title={intl.formatMessage({id:"app.activity.helpVideoTitle"})}
          
          videoId="VGgMWaTh2eo"
        />
      </SideModal>
      <ProductGuideModal
        isOpen={showActivityGuide}
        onClose={closeActivityGuide}
        modalTitleId="app.activity.guide.modalTitle"
        steps={ACTIVITY_BOARDS_GUIDE_STEPS}
        persistDismissKey="activities"
      />
    </Layout>
  );
};
